export const PAID_ESTADO_PAGO_VALUES = [
  "cobrado",
  "pagado",
  "completado",
  "paid",
];

export const FORM_STATE_SESSION_KEY = "tipify_form_state";

export const TIP_ALREADY_PAID_CODE = "TIP_ALREADY_PAID";

export function isTipPaid(estadoPago) {
  const estado = (estadoPago || "").toLowerCase();
  return PAID_ESTADO_PAGO_VALUES.includes(estado);
}

export function clearTipFormSession() {
  try {
    sessionStorage.removeItem(FORM_STATE_SESSION_KEY);
  } catch (error) {
    console.error("Error limpiando estado de sessionStorage:", error);
  }
}

export function isTipAlreadyPaidError(error) {
  return (
    error?.response?.status === 409 &&
    error?.response?.data?.code === TIP_ALREADY_PAID_CODE
  );
}

export function leavePaidTipPayment(navigate, businessId) {
  clearTipFormSession();
  navigate(`/${businessId}`, { replace: true });
}
